module.exports = "<p>\n  my-timesheets works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/time/components/my-timesheets/my-timesheets.component.html
// module id = ./src/app/modules/time/components/my-timesheets/my-timesheets.component.html
// module chunks = main